export enum ProductPackageSubscriptionTypeEnum {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}
